export enum NdcPageVariant {
    READ,
    CREATE,
    CLONE,
}
